import useSWRMutation from 'swr/mutation';
import letrusAPI from '../axiosInstance';
import {StudentAnnualReport, StudentAnnualReportParams} from './types';

export function fetchStudentAnnualReport() {
  return useSWRMutation<
    StudentAnnualReport,
    Error,
    string,
    StudentAnnualReportParams
  >(
    '/api/v1/student_report/annual',
    async (url, {arg}) => {
      const {id, competenceId} = arg;

      const query = new URLSearchParams({
        review_grid: String(id),
        ...(competenceId != null && {competence: String(competenceId)}),
      });

      const response = await letrusAPI(`${url}?${query}`, {method: 'get'});

      return response.data;
    },
    {throwOnError: false},
  );
}
